import { render } from "./logistics.vue?vue&type=template&id=d8fa1890&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=js"
export * from "./logistics.vue?vue&type=script&lang=js"

import "./logistics.vue?vue&type=style&index=0&id=d8fa1890&lang=scss&scoped=true"
import "./logistics.vue?vue&type=style&index=1&id=d8fa1890&lang=css"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8fa1890"]])

export default __exports__